const dateConvert = (date) => {
    return new Date(date).toLocaleString()
}

export default dateConvert
